//validateCPF foi pego uma função pronta
const validateCPF = v => {
  const cpf = v.replace(/[^\d]+/g, '')
  const sequencialNumbersRegex = /^(\d)\1+$/g
  const isSequencialNumber = sequencialNumbersRegex.test(cpf)

  if (cpf === '') return false
  if (cpf.length !== 11) return false
  if (isSequencialNumber) return false

  // Valida 1o digito
  let add = 0
  for (var i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i)
  let rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) rev = 0
  if (rev !== parseInt(cpf.charAt(9))) return false
  // Valida 2o digito
  add = 0
  for (i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i)
  rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) rev = 0
  if (rev !== parseInt(cpf.charAt(10))) return false
  return true
}

const maskCPF = value => {
  if (!value) return { unmaskedCPF: '', maskedCPF: '' }
  const unmaskedCPF = value.replace(/\D/g, '')

  let cpf = unmaskedCPF.replace(/(\d{3})(\d)/, '$1.$2')
  cpf = cpf.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
  cpf = cpf.replace(/(\d{3})(\d)/, '$1-$2')

  return { maskedCPF: cpf.substring(0, 14), unmaskedCPF }
}

export { validateCPF, maskCPF }
